import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  section: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  option: {
    color: theme.onCard.white
  },
  plus: {
    color: theme.onCard.beige_50_op_75
  },
  disabled: {
    color: theme.onCard.beige_50_op_13
  }
});

export default makeStyles(styles);
